<aero-input
  type="text"
  id="groupToken"
  name="groupToken"
  [required]="true"
  [(ngModel)]="groupToken"
  (ngModelChange)="changed()"
  [placeholder]="'account_settings_memberships_join_placeholder' | translate"
  label="{{ 'account_settings_memberships_access_token' | translate }}">
</aero-input>
<p class="join-organization-description">
  {{ 'account_settings_memberships_join_description' | translate }}
</p>
